type EditTaskError = {
  emptyName: boolean;
  duplicateName: boolean;
  invalidDateRange: boolean;
  startDateOutOfBound: boolean;
  notFound: boolean;
  listNotFound: boolean;
};

const editTaskError: EditTaskError = {
  emptyName: false,
  duplicateName: false,
  invalidDateRange: false,
  startDateOutOfBound: false,
  notFound: false,
  listNotFound: false,
};

export type { EditTaskError };

export { editTaskError };
